var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { formatDate } from '../../utils/date';
export function useVipProgram() {
    var _a = useI18n(), t = _a.t, i18n = _a.i18n;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var user = useContext(UserContext).user;
    var _b = useState(undefined), perks = _b[0], setPerks = _b[1];
    var _c = useState(0), timeRemaining = _c[0], setTimeRemaining = _c[1];
    var _d = useState(0), stakingVp = _d[0], setStakingVp = _d[1];
    var _e = useState(0), consumptionVp = _e[0], setConsumptionVp = _e[1];
    var _f = useState(0), goldPoints = _f[0], setGoldPoints = _f[1];
    var _g = useState(0), redPoints = _g[0], setRedPoints = _g[1];
    var _h = useState([]), history = _h[0], setHistory = _h[1];
    useEffect(function () {
        function getPerks() {
            return __awaiter(this, void 0, void 0, function () {
                var result, days, now, end, time, newGoldPoints, newRedPoints, _i, _a, detail, diff;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress))
                                return [2 /*return*/];
                            setServerLoading(true);
                            return [4 /*yield*/, gqlSdk.UserGetLoyaltyState()];
                        case 1:
                            result = _b.sent();
                            days = 0;
                            if (result.userGetLoyaltyState.loyaltyPointsNextDecreaseAt !== null) {
                                now = moment();
                                end = moment(result.userGetLoyaltyState.loyaltyPointsNextDecreaseAt);
                                time = moment.duration(end.diff(now));
                                days = time.asDays();
                            }
                            newGoldPoints = 0;
                            newRedPoints = 0;
                            for (_i = 0, _a = result.userGetLoyaltyState.loyaltyPointsDetails; _i < _a.length; _i++) {
                                detail = _a[_i];
                                diff = moment(detail.expireAt).diff(moment(), 'days');
                                if (diff > 28)
                                    newGoldPoints += detail.amount;
                                else
                                    newRedPoints += detail.amount;
                            }
                            setGoldPoints(newGoldPoints);
                            setRedPoints(newRedPoints);
                            setHistory(result.userGetLoyaltyState.loyaltyPointsDetails
                                .sort(function (a, b) { return moment(a.expireAt).diff(b.expireAt); })
                                .map(function (detail) { return ({
                                dateStart: formatDate(detail.createdAt.split('T')[0], i18n.language),
                                source: t("vip-program.source-type.".concat(detail.source.toLowerCase().replaceAll('_', '-'))),
                                vipPoints: detail.amount,
                                dateEnd: formatDate(detail.expireAt.split('T')[0], i18n.language),
                            }); }));
                            setPerks(result.userGetLoyaltyState);
                            setTimeRemaining(Math.round(days));
                            setStakingVp(result.userGetLoyaltyState.loyaltyPointsFromCtaTokenStake !== 0
                                ? Math.round((result.userGetLoyaltyState.loyaltyPointsFromCtaTokenStake * 100) /
                                    result.userGetLoyaltyState.loyaltyPoints)
                                : 0);
                            setConsumptionVp(result.userGetLoyaltyState.loyaltyPointsFromCtaTokenSpend !== 0
                                ? Math.round((result.userGetLoyaltyState.loyaltyPointsFromCtaTokenSpend * 100) /
                                    result.userGetLoyaltyState.loyaltyPoints)
                                : 0);
                            setServerLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getPerks();
    }, [user]);
    return { perks: perks, timeRemaining: timeRemaining, stakingVp: stakingVp, consumptionVp: consumptionVp, history: history, goldPoints: goldPoints, redPoints: redPoints };
}
